var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:['info-page-rows', {'info-page-rows--in-row': _vm.inRow}]},[_c('div',{staticClass:"info-page-rows__label"},[_vm._v(_vm._s(_vm.label))]),_vm._v(" "),_c('div',{staticClass:"info-page-rows__content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }